export const percentageCalculate = (totalValue: number, value: number) => (value * 100) / totalValue
